var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBotClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.758713 14.1343C0.368189 14.5248 0.368189 15.158 0.758713 15.5485C1.14924 15.939 1.7824 15.939 2.17293 15.5485L8.30155 9.41986L14.4302 15.5485C14.8207 15.939 15.4539 15.939 15.8444 15.5485C16.2349 15.158 16.2349 14.5248 15.8444 14.1343L9.71577 8.00565L15.8437 1.87776C16.2342 1.48724 16.2342 0.854071 15.8437 0.463547C15.4531 0.0730227 14.82 0.0730237 14.4294 0.463548L8.30155 6.59144L2.17367 0.463548C1.78314 0.0730237 1.14998 0.0730227 0.759451 0.463547C0.368927 0.854071 0.368927 1.48724 0.759451 1.87776L6.88734 8.00565L0.758713 14.1343Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotClose);
export default __webpack_public_path__ + "static/media/bot-close.28683773de7ee337ffe0023009c6fb96.svg";
export { ForwardRef as ReactComponent };